export const MANAGE_OWNER_MANAGER_REQUEST = 'MANAGE_OWNER_MANAGER_REQUEST'
export const MANAGE_OWNER_MANAGER_SUCCESS = 'MANAGE_OWNER_MANAGER_SUCCESS'
export const MANAGE_OWNER_MANAGER_FALIURE = 'MANAGE_OWNER_MANAGER_FALIURE'

export const GET_OWNER_MANAGER_REQUEST = 'GET_OWNER_MANAGER_REQUEST'
export const GET_OWNER_MANAGER_SUCCESS = 'GET_OWNER_MANAGER_SUCCESS'
export const GET_OWNER_MANAGER_FALIURE = 'GET_OWNER_MANAGER_FALIURE'

export const UPDATE_PHONE_NUMBERS_REQUEST = 'UPDATE_PHONE_NUMBERS_REQUEST'
export const UPDATE_PHONE_NUMBERS_SUCCESS = 'UPDATE_PHONE_NUMBERS_SUCCESS'
export const UPDATE_PHONE_NUMBERS_FALIURE = 'UPDATE_PHONE_NUMBERS_FALIURE'

export const GET_PHONE_NUMBERS_REQUEST = 'GET_PHONE_NUMBERS_REQUEST'
export const GET_PHONE_NUMBERS_SUCCESS = 'GET_PHONE_NUMBERS_SUCCESS'
export const GET_PHONE_NUMBERS_FALIURE = 'GET_PHONE_NUMBERS_FALIURE'
export const RESET_ACCOUNT = 'RESET_ACCOUNT'